export default __webpack_public_path__ + "static/media/mail.e5fe2131.svg";